import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { TEMPLATE_REGISTRY } from "./registry";
import {
  TemplateTrackingProvider,
  useTemplateName,
  useTemplateResolved,
} from "./TemplateTrackingProvider";
import * as actions from "../../redux/actions/catalogActions";

/**
 * Resolves the active template for the current visitor, lazy-loads it,
 * wraps it in the TemplateTrackingProvider so all track() calls automatically
 * carry { template: codename }, and renders it.
 *
 * SSR renders "original" (the safe default). The client resolves the actual
 * template on hydration.
 */
function TemplateResolverInner({ catalog, actions: catalogActions }) {
  const codename = useTemplateName();
  const isTemplateResolved = useTemplateResolved();
  const resolvedCodename = TEMPLATE_REGISTRY[codename] ? codename : "original";
  const TemplateComponent = TEMPLATE_REGISTRY[resolvedCodename];

  return (
    <TemplateTrackingProvider codename={resolvedCodename}>
      <TemplateComponent
        catalog={catalog}
        actions={catalogActions}
        templateReady={isTemplateResolved}
      />
    </TemplateTrackingProvider>
  );
}

TemplateResolverInner.propTypes = {
  catalog: PropTypes.object,
  actions: PropTypes.object,
};

const mapStateToProps = (state) => ({
  catalog: state.catalogReducer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateResolverInner);
